import { CloseOutlined, SyncOutlined } from '@ant-design/icons';
import { AccessToken } from '@mm/state/model/ConnectionModel';
import classNames from 'classnames';
import React, { MouseEvent } from 'react';
import { PrimaryButton } from '../../../../../../../../common/buttons/PrimaryButton/PrimaryButton';
import { OauthTokenStatus } from '../OauthTokenStatus/OauthTokenStatus';
import styles from '../KlaviyoIntegrations/KlaviyoIntegrations.module.css';
import { HelpCenter } from '../../../../../../../../common/components/HelpCenter/HelpCenter';

type Props = {
  helpLink: string;
  token: AccessToken | undefined;
  connectToken: (tokenId?: number) => void;
  revoke: (tokenId: number) => void;
  controlsDisabled: boolean;
  heading?: string;
  connectedTooltipMsg?: string;
};

export const OauthTokenConnection = (props: Props) => {
  const {
    heading,
    token,
    helpLink,
    connectToken,
    revoke,
    controlsDisabled,
    connectedTooltipMsg,
  } = props;

  const revokeToken = (e?: MouseEvent<HTMLButtonElement>) => {
    e?.stopPropagation();
    if (token) {
      revoke(token.id);
    }
  };

  const connect = (e?: MouseEvent<HTMLButtonElement>) => {
    e?.stopPropagation();

    connectToken(token?.id);
  };

  return (
    <div
      className={classNames(styles.box, styles.boxWithHelp, {
        [styles.boxDisabled]: controlsDisabled,
      })}
    >
      <div className={styles.boxContent}>
        {heading && <div className={styles.heading}>{heading}</div>}
        <div
          className={classNames(
            styles.connectionButtonsWrapper,
            styles.noMarging,
          )}
        >
          {!token ? (
            <PrimaryButton
              className={classNames(
                'integrations__header-add-button-secondary',
                'integrations__header-add-button-action',
                'integrations__header-button-no-margin',
              )}
              onClick={e => connect(e)}
            >
              Connect
            </PrimaryButton>
          ) : (
            <>
              <OauthTokenStatus
                token={token}
                styles={styles}
                connectedTooltipMsg={connectedTooltipMsg}
              />
              <PrimaryButton
                className={classNames(
                  'integrations__header-add-button-secondary',
                  'integrations__header-add-button-action',
                  'integrations__header-button-no-margin',
                )}
                onClick={e => connect(e)}
                leftIcon={<SyncOutlined />}
              >
                Reconnect
              </PrimaryButton>
              <PrimaryButton
                className={classNames(
                  'integrations__header-add-button-secondary',
                  'integrations__header-add-button-action',
                  'integrations__header-button-no-margin',
                )}
                onClick={e => revokeToken(e)}
                leftIcon={<CloseOutlined />}
              >
                Disconnect
              </PrimaryButton>
            </>
          )}
        </div>
      </div>
      <HelpCenter helpLink={helpLink} className={styles.help} />
    </div>
  );
};
